import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "../../i18n";
import { Warning } from "../notices/Warning";

export const AddressValidationError: FC<{
  network: string;
  isRujira?: boolean;
  className?: string;
}> = ({ network, isRujira = false, className }) => {
  const { t } = useTranslation("common");

  return (
    <Warning
      role="alert"
      color="red"
      className={clsx("warning--sm mt-1 condensed flex ai-c", className)}
      msg={
        isRujira
          ? t("validRujiraAddress")
          : t("validNetworkAddress", { network })
      }
    />
  );
};
